import { Drawer } from '@mui/material';
import PropTypes from 'prop-types';
import { queryAdderPopupPaperSx } from './queryAdderPopupStyles';

function getDrawerPaddingSx({ flush, useLegacyPadding }) {
  if (flush) {
    return { p: 0 };
  }

  if (useLegacyPadding) {
    return { p: '20px 40px' };
  }

  return {};
}

function QueryAdderDrawer({ children, openForm, setOpenForm, flush = false, useLegacyPadding = false }) {
  return (
    <Drawer
      open={openForm}
      onClose={() => setOpenForm(false)}
      PaperProps={{
        sx: {
          ...queryAdderPopupPaperSx,
          borderTop: 'none',
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          top: 0,
          height: '100%',
          width: '65vw',
          minWidth: useLegacyPadding ? '960px' : '1000px',
          maxWidth: '1480px',
          ...getDrawerPaddingSx({ flush, useLegacyPadding }),
        },
      }}
      disableEnforceFocus
      anchor="right"
    >
      {children}
    </Drawer>
  );
}

QueryAdderDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  openForm: PropTypes.bool.isRequired,
  setOpenForm: PropTypes.func.isRequired,
  flush: PropTypes.bool,
  useLegacyPadding: PropTypes.bool,
};

export default QueryAdderDrawer;
